import { GetProductByMerchantFilteredRequest } from './../../../../models/product/get-product-by-merchant-filtered';
import { ProductItems } from '../../../../models/product/get-product-request';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  ViewChild,
  AfterViewInit,
  ViewEncapsulation,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import { AppDataService, ProductService, StoreService } from 'app/services';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { AddProductDialogComponent } from './add-product-dialog/add-product-dialog.component';
import { AddProductSingleDialogComponent } from './add-product-single-dialog/add-product-single-dialog.component';
import { AddProductMultipleDialogComponent } from './add-product-multiple-dialog/add-product-multiple-dialog.component';
import { ViewProductDialogComponent } from './view-product-dialog/view-product-dialog.component';
import { EditProductDialogComponent } from './edit-product-dialog/edit-product-dialog.component';

export enum ViewModeEnum {
  GridView,
  TableView,
  List, // For future implementation
}

export enum UploadType {
  None,
  Single,
  Multiple,
  Uploaded,
}
@Component({
  selector: 'merchant-products',
  templateUrl: './merchant-products.component.html',
  styleUrls: [
    './merchant-products.component.scss',
    '../../../../../styles/style-layout.scss',
    '../../../../../styles/m3-defaul-material-theme.scss',
  ],
  providers: [MessageService],
})
export class MerchantProductsComponent
  implements OnInit, AfterViewInit, OnChanges
{
  @Input()
  public menuPermissionActive!: string;

  @Input() mode!: ViewModeEnum;
  @Input() store: any;
  @Input() merchantId: number | any;

  @Output() changedProductsCountEmit = new EventEmitter<boolean>();
  @Output() showNextButtonEmit = new EventEmitter<boolean>();

  changedProductsCount(increased: any) {
    this.changedProductsCountEmit.emit(increased);
  }

  public selectedViewMode = ViewModeEnum.GridView; // Default view
  public viewMode = ViewModeEnum;

  public isMerchant: boolean = false;

  //---------------Products----------------------
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  public productItems = new Array<ProductItems>();

  // Grid settings
  public productRowsPerPage: number = 20;
  public productSkip = 0;
  public productRowsPerPageOptions: Array<number> = [20, 100, 500, 1000];
  public productTotalRecords: number = -1;
  public productPageIndex = 0;

  public productFirst: number = 0;
  public productSortField: string | string[] = '';
  private productSortOrder: number = 1;

  public selectedProductId: number = 0;
  public selectedProducts: any;
  public moreItems: MenuItem[] = [
    {
      label: 'Reject',
      command: () => {
        this.openMerchantApprovedRejectProductSideBar(this.selectedProductId);
      },
    },
  ];

  public filter: {
    searchName: string;
  } = { searchName: '' };
  private searchTimer: number = 0;
  //---------------End Products----------------------

  //------------------MerchantCreateProduct---------------------
  public showMerchantCreateProductSideBar: boolean = false;
  //-------------------------------------------------------------
  //------------------MerchantEdit/DetailProduct---------------------
  public showMerchantEditProductSideBar: boolean = false;
  public showMerchantDetailProductSideBar: boolean = false;
  public showMerchantApprovedRejectProductSideBar: boolean = false;
  public productId: number = 0;
  //-------------------------------------------------------------

  public loading: boolean = false;
  public noInternetConnection: boolean = false;
  showViewProductSidebar = false;

  constructor(
    private messageService: MessageService,
    public appData: AppDataService,
    public productService: ProductService,
    private storeService: StoreService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    this.isMerchant = this.appData.isMerchant();
  }

  ngOnInit(): void {
    // Products will be loaded when store input is available via ngOnChanges
    this.checkInternetConnection();
    this.setupNetworkListeners();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['store'] && changes['store'].currentValue) {
      // Store object is now available, load products
      this.getProductsByStore(0);
    }
  }

  ngAfterViewInit(): void {}

  public loadProductsAfterDelete() {
    this.productItems = [];
    this.getProductsByStore(0);
  }

  public handleLazyLoadGrid(event: any) {
    this.productSkip += 20;
    this.getProductsByStore(this.productSkip);
  }

  public handleProductLazyLoadTable(event: PageEvent): void {
    let skip = 0;
    if (event.pageIndex < this.productPageIndex) {
      skip = this.productSkip - event.pageSize;
    } else {
      skip = this.productSkip + event.pageSize;
    }

    if (event.pageSize !== this.productRowsPerPage) {
      skip = 0;
    }
    this.productRowsPerPage = event.pageSize;
    this.productSkip = skip;
    this.productPageIndex = event.pageIndex;

    this.getProductsByStore(skip);
  }

  public openAddProductDialog() {
    const ref = this.dialog.open(AddProductDialogComponent, {
      width: '1000px',
      minWidth: '1000px',
    });

    ref.afterClosed().subscribe((uploadType) => {
      if (uploadType === UploadType.Single) {
        const refAddSingleDialog = this.dialog.open(
          AddProductSingleDialogComponent,
          {
            width: '1000px',
            minWidth: '1000px',
            disableClose: true,
            data: { merchantId: this.merchantId, store: this.store }
          }
        );

        refAddSingleDialog.afterClosed().subscribe((data: UploadType) => {
          if (data === UploadType.Uploaded) {
            // Refresh the product list from API
            this.productItems = [];
            this.getProductsByStore(0);
          } else {
            this.openAddProductDialog();
          }
        });
      } else if (uploadType === UploadType.Multiple) {
        const refAddMultipleDialog = this.dialog.open(AddProductMultipleDialogComponent, {
          maxWidth: '1000px',
          //disableClose: true
        });

        refAddMultipleDialog.afterClosed().subscribe((data: UploadType) => {
          if (data === UploadType.Uploaded) {
            // Refresh the product list from API
            this.getProductsByStore(0);
          }
        });
      }
    });
  }

  public openMerchantEditProductSideBar(productId: number) {
    this.productId = productId;
    this.showMerchantEditProductSideBar =!this.showMerchantEditProductSideBar;
  }

  changeView(viewMode: ViewModeEnum) {
    this.selectedViewMode = viewMode;
  }

  public getProductsByStore(skip: number, afterEdit = false) {
    // Guard against missing store object
    if (!this.store?.Id) {
      return;
    }

    const dto = {
      MerchantId: this.merchantId,
      StoreId: this.store.Id,
      Skip: skip,
      Take: this.productRowsPerPage,
      SortField: this.productSortField,
      SortOrder: this.productSortOrder,
      SearchName: this.filter.searchName,
    };

    this.loading = true;
    this.cdr.detectChanges(); // detect change to allow child components to react

    this.productService
        .getProductsByStore(dto, this.messageService)
        .then((data) => {
          this.loading = false;
          if (!data.Success) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: data.ErrorMessage,
            });
            return;
          }
          if (data.Items !== null) {
            // TODO
            // this.products = data.Items.map((x: any) => {
            //     x.PublishedPrice = '₱ ' + x.PublishedPrice;
            //     return x;
            // });
            if (this.viewMode.GridView === this.selectedViewMode) {
              if (afterEdit) {
                this.productItems = data.Items;
                this.productFirst = skip;
                this.loading = false;
                return;
              }

              const currentProductList = this.productItems;
              if (data.Items.length !== 0) {
                currentProductList.push(...data.Items);
              }

              this.productItems = [...currentProductList];
              this.productFirst = skip;
              this.productTotalRecords = data.TotalRecords;
              this.cdr.detectChanges();
            } else if (this.viewMode.TableView === this.selectedViewMode) {
              this.productItems = data.Items;
              this.productFirst = skip;
              this.productTotalRecords = data.TotalRecords;
            }
          } else {
            if (this.viewMode.TableView === this.selectedViewMode) {
              this.productItems = [];
            }
          }
          this.productFirst = skip;
          this.productTotalRecords = data.TotalRecords;
          this.loading = false;
          this.changedProductsCount(this.productTotalRecords);
        })
        .catch((err) => {
          this.loading = false;
          this.handleNetworkError(err);
        });
  }

  public getProductsByMerchant(skip: number) {
    const dto = {
      MerchantId: this.merchantId,
      Skip: skip,
      Take: this.productRowsPerPage,
      SortField: this.productSortField,
      SortOrder: this.productSortOrder,
      SearchName: this.filter.searchName,
    };

    this.loading = true;
    this.cdr.detectChanges(); // detect change to allow child components to react

    this.productService
      .getProductsByMerchant(dto, this.messageService)
      .then((data) => {
        this.loading = false;
        if (!data.Success) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: data.ErrorMessage,
          });
          return;
        }
        if (data.Items !== null) {
          // TODO
          // this.products = data.Items.map((x: any) => {
          //     x.PublishedPrice = '₱ ' + x.PublishedPrice;
          //     return x;
          // });
          if (this.viewMode.GridView === this.selectedViewMode) {
            const currentProductList = this.productItems;
            if (data.Items.length !== 0) {
              currentProductList.push(...data.Items);
            }

            this.productItems = [...currentProductList];
            this.productFirst = skip;
            this.productTotalRecords = data.TotalRecords;
            this.cdr.detectChanges();
          } else if (this.viewMode.TableView) {
            this.productItems = data.Items;
            this.productFirst = skip;
            this.productTotalRecords = data.TotalRecords;
          }
        } else {
          if (this.viewMode.TableView === this.selectedViewMode) {
            this.productItems = [];
          }
        }
        this.productFirst = skip;
        this.productTotalRecords = data.TotalRecords;
        this.loading = false;
        this.changedProductsCount(this.productTotalRecords);
      })
      .catch((err) => {
        this.loading = false;
        this.handleNetworkError(err);
      });
  }

  onFilterMerchantProduct(dto: GetProductByMerchantFilteredRequest) {
    this.loading = true;
    this.productService
      .getProductByMerchantFiltered(dto, this.messageService)
      .then((response) => {
        if (!response) {
          return;
        }
        if (!response.Success) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.ErrorMessage,
          });
        }

        this.loading = false;
        this.productTotalRecords = response.TotalRecords;
        this.productPageIndex = 0;
        this.productFirst = 0; // Skip always set to 0 when applying filter
        this.productItems = response.Items;
      })
      .catch((err) => {
        throw err;
      });
  }

  showViewProductSidebarEmit(event: any){
    this.showViewProductSidebar = event;
  }

  public openViewProductDialog(productItem: ProductItems) {
    const ref = this.dialog.open(ViewProductDialogComponent, {
      width: '600px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      data: { productItem },
      disableClose: false,
      autoFocus: false,
      panelClass: 'product-view-dialog'
    });

    ref.afterClosed().subscribe((result) => {
      if (result?.action === 'edit') {
        this.openEditProductDialog(result.product);
      } else if (result?.action === 'remove') {
        // Handle remove action if needed
        this.handleRemoveProduct(result.productId);
      }
    });
  }

  public openEditProductDialog(product: ProductItems) {
    const ref = this.dialog.open(EditProductDialogComponent, {
      width: '1000px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      data: { product },
      disableClose: false,
      autoFocus: false,
      panelClass: 'edit-product-dialog'
    });

    ref.afterClosed().subscribe((result) => {
      if (result?.action === 'save' && result?.product) {
        // Update the existing product in the array instead of refreshing the entire list
        this.updateProductInArray(result.product);
      }
    });
  }

  private updateProductInArray(updatedProduct: ProductItems): void {
    // Find the index of the product in the array
    const index = this.productItems.findIndex(p => p.Id === updatedProduct.Id);
    if (index !== -1) {
      this.getProductsByStore(0, true);
    }
  }

  public handleRemoveProduct(productItemId: number) {
    // Show confirmation dialog before deleting
    if (confirm('Are you sure you want to delete this product? This action cannot be undone.')) {
      this.loading = true;
      // Prepare data for API call
      const deleteData = {
        Id: productItemId,
        MerchantId: this.merchantId
      };
      // Call the delete API
      this.storeService.deleteProductItem(deleteData, this.messageService)
        .then(response => {
          this.loading = false;
          if (response && response.Success) {
            // Remove from the current array
            this.productItems = this.productItems.filter(p => p.Id !== productItemId);
            this.productTotalRecords--;
            // Show success message
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Product deleted successfully'
            });
          } else {
            // Show error message
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: response?.ErrorMessage || 'Failed to delete product'
            });
          }
        })
        .catch(error => {
          this.loading = false;
          // Show error message
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'An error occurred while deleting the product'
          });
        });
    }
  }
  changedShowMerchantDetailProductSideBarEmit(value: any) {
    this.showMerchantDetailProductSideBar = value.visible;

    if (value.needUpdateProducts) {
      this.getProductsByStore(0);
    }
  }

  public openMerchantApprovedRejectProductSideBar(productId: number) {
    this.productId = productId;
    this.showMerchantApprovedRejectProductSideBar =
      !this.showMerchantApprovedRejectProductSideBar;
  }
  changedShowMerchantApprovedRejectProductSideBarEmit(value: any) {
    this.showMerchantApprovedRejectProductSideBar = value;
  }

  public openMerchantDetailProductSideBar(productId: number) {
    this.productId = productId;
    this.showMerchantDetailProductSideBar =
      !this.showMerchantDetailProductSideBar;
  }

  changedShowMerchantCreateProductSideBarEmit(value: any) {
    this.showMerchantCreateProductSideBar = value;
    if (value === false) {
      this.getProductsByStore(0);
    }
  }

  changedShowMerchantEditProductSideBarEmit(value: any) {
    this.showMerchantEditProductSideBar = value.visible;
    if (value.productIsEdited) {
      this.getProductsByStore(0);
    }
  }

  public setSelectedProductId(productId: number) {
    this.selectedProductId = productId;
  }

  public switchProduct(product: any) {
    this.updateProductIsEnable(product.Id);
  }

  public handleFilterChange(): void {
    if (this.noInternetConnection) {
      return; // Don't make API calls when offline
    }

    if (this.searchTimer) {
      window.clearTimeout(this.searchTimer);
    }

    this.searchTimer = window.setTimeout(() => {
      this.productItems = [];
      this.getProductsByStore(0);
      this.searchTimer = 0;
    }, 1500);
  }

  public openMerchantCreateProductSideBar() {
    this.showMerchantCreateProductSideBar =
      !this.showMerchantCreateProductSideBar;
  }

  private updateProductIsEnable(productId: number) {
    const dto = {
      MerchantId: this.merchantId,
      ProductId: productId,
    };

    this.productService
      .updateProductIsEnable(dto, this.messageService)
      .then((data) => {
        this.loading = false;

        if (!data) {
          return;
        }

        if (!data.Success) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: data.ErrorMessage,
          });
          return;
        }
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Data updated successfully',
        });
      })
      .catch((err) => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err,
        });
      });
  }
  /** Candidate to remove ends here **************************************************************************/

  public checkInternetConnection(): void {
    this.noInternetConnection = !navigator.onLine;
  }

  public isActionDisabled(): boolean {
    return this.noInternetConnection;
  }

  private setupNetworkListeners(): void {
    window.addEventListener('online', () => {
      this.noInternetConnection = false;
      this.cdr.detectChanges();
      // Retry loading products when connection is restored
      if (this.store?.Id) {
        this.getProductsByStore(0);
      }
    });

    window.addEventListener('offline', () => {
      this.noInternetConnection = true;
      this.cdr.detectChanges();
    });
  }

  private handleNetworkError(err: any): void {
    // Check if it's a network error
    if (err.name === 'NetworkError' ||
        err.message?.includes('Network') ||
        err.message?.includes('fetch') ||
        !navigator.onLine) {
      this.noInternetConnection = true;
      this.cdr.detectChanges();
    } else {
      // Show regular error message for non-network errors
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: err,
      });
    }
  }
}
